import { render, staticRenderFns } from "./ElibraryArtikelView.vue?vue&type=template&id=dd5eaebc&scoped=true"
import script from "./ElibraryArtikelView.vue?vue&type=script&lang=js"
export * from "./ElibraryArtikelView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd5eaebc",
  null
  
)

export default component.exports